import { useState } from "react";
import { useTranslation } from "react-i18next";
import { useFormikContext } from "formik";

import { InvestObjectsContainerProps } from "./InvestObjects.types";

import {
  CALCULATOR_OBJECT_TYPES,
  CALCULATOR_PARKING_TYPES,
  CALCULATOR_TYPES,
} from "constants/calculator";

import {
  getDefaultParkingValues,
  getDefaultApartmentValues,
} from "../../CalculatorForm.helpers";

import InvestObjects from "./InvestObjects";

const InvestObjectsContainer = ({
  activeTab,
  isDesktop,
  isRootAdmin,
  calculatorType,
  calculationValues,
}: InvestObjectsContainerProps) => {
  const { t } = useTranslation();
  const { values, setFieldValue } = useFormikContext<any>();

  const [activeObject, setActiveObject] = useState<any>(
    isDesktop || calculatorType === CALCULATOR_TYPES.BASIC ?
    {
      type: CALCULATOR_OBJECT_TYPES.APARTMENT,
      index: 0,
    }
    : {
      type: null,
      index: null,
    }
  );

  const handleAddObjectClick = (type: string) => {
    if (
      type === CALCULATOR_PARKING_TYPES.PARKING_UNDERGROUND ||
      type === CALCULATOR_PARKING_TYPES.PARKING_GARAGE
    ) {
      // pushUserEvent({
      //   eventContextFields: {
      //     eventAction: "click",
      //     eventLabel: "calculatorAddParking",
      //   },
      // });

      // pushAmplitudeEvent({
      //   eventName: "calculator_add_parking",
      // });

      setFieldValue("parkings", [
        ...values.parkings,
        {
          ...getDefaultParkingValues(calculationValues, t),
          parkingDinSize: calculationValues?.parkingDinSize || "11,5",
          parkingType: type,
        },
      ]);

      setActiveObject({
        type: CALCULATOR_OBJECT_TYPES.PARKING,
        index: values.parkings.length,
      });
    }

    if (type === CALCULATOR_PARKING_TYPES.PARKING_OUTDOOR) {
      // pushUserEvent({
      //   eventContextFields: {
      //     eventAction: "click",
      //     eventLabel: "calculatorAddParking",
      //   },
      // });

      // pushAmplitudeEvent({
      //   eventName: "calculator_add_parking",
      // });

      setFieldValue("parkings", [
        ...values.parkings,
        { ...getDefaultParkingValues(calculationValues, t), parkingType: type },
      ]);

      setActiveObject({
        type: CALCULATOR_OBJECT_TYPES.PARKING,
        index: values.parkings.length,
      });
    }

    if (type === CALCULATOR_OBJECT_TYPES.APARTMENT) {
      // pushUserEvent({
      //   eventContextFields: {
      //     eventAction: "click",
      //     eventLabel: "calculatorAddApartment",
      //   },
      // });

      // pushAmplitudeEvent({
      //   eventName: "calculator_add_apartment",
      // });

      setFieldValue("apartments", [
        ...values.apartments,
        getDefaultApartmentValues(calculationValues, t),
      ]);

      setActiveObject({
        type: CALCULATOR_OBJECT_TYPES.APARTMENT,
        index: values.apartments.length,
      });
    }
  };

  const handleObjectRemoveClick = (type: string, index: number) => {
    if (type === CALCULATOR_OBJECT_TYPES.PARKING) {
      const nextParkings = values.parkings.filter(
        (_: any, i: number) => i !== index
      );

      setFieldValue("parkings", nextParkings);

      if (nextParkings.length > 0) {
        setActiveObject({
          type: CALCULATOR_OBJECT_TYPES.PARKING,
          index: nextParkings.length - 1,
        });
      }

      if (nextParkings.length === 0) {
        setActiveObject({
          type: CALCULATOR_OBJECT_TYPES.APARTMENT,
          index: values.apartments.length - 1,
        });
      }
    }

    if (type === CALCULATOR_OBJECT_TYPES.APARTMENT) {
      const nextApartments = values.apartments.filter(
        (_: any, i: number) => i !== index
      );

      setFieldValue("apartments", nextApartments);

      setActiveObject({
        type: CALCULATOR_OBJECT_TYPES.APARTMENT,
        index: nextApartments.length - 1,
      });
    }
  };

  const handleObjectClick = (type: string, index: number) => {
    setActiveObject({ type, index });
  };

  return (
    <InvestObjects
      activeTab={activeTab}
      isDesktop={isDesktop}
      isRootAdmin={isRootAdmin}
      values={values}
      calculatorType={calculatorType}
      activeObject={activeObject}
      calculationValues={calculationValues}
      onAddObjectClick={handleAddObjectClick}
      onObjectRemoveClick={handleObjectRemoveClick}
      onObjectClick={handleObjectClick}
    />
  );
};

export default InvestObjectsContainer;
